import { z } from 'zod';
import {
  clickthroughHeadCellType,
  clickthroughMetricsPrefix,
  clickthroughOriginalValue,
  clickthroughPercentageComplement,
  clickthroughTablePage,
  clickthroughUniqueBy,
  clickthroughWidgetId,
} from '../views/CustomDashboards/components/Clickthrough/consts';
import {
  transformToBoolean,
  transformToNumber,
  transformToString,
  transformToStringArray,
  transformToStringArrayOrNull,
  transformToStringOrNull,
} from './utils';

export const componentSchema = {
  AvTableSchema: z.object({
    orderBy: transformToStringArray,
  }),
  ClickthroughSchema: z.object({
    [clickthroughPercentageComplement]: z.coerce.boolean().array().optional(),
    [clickthroughMetricsPrefix]: transformToString,
    [clickthroughWidgetId]: transformToString,
    [clickthroughTablePage]: transformToNumber,
    [clickthroughUniqueBy]: transformToBoolean,
  }),
  Tickets: z.object({
    ticketCategory: transformToString,
  }),
  VisualExplorer: z.object({
    rootProjection: transformToString,
    rootId: transformToString,
    projection: transformToString,
    id: transformToString,
  }),
  Reports: z.object({
    expressions: transformToString,
    isEditMode: transformToBoolean,
  }),
  Runs: z.object({
    guidId: transformToString,
  }),
  Sources: z.object({
    tablePage: transformToNumber,
  }),
  Dashboards: z.object({
    dataSelectTypes: transformToString,
    [clickthroughOriginalValue]: transformToStringArrayOrNull,
    [clickthroughHeadCellType]: transformToStringOrNull,
    isEditMode: transformToBoolean,
    isEditWidgetOpen: transformToBoolean,
    tab: transformToString,
    fieldType: transformToString,
  }),
  oltpPagination: z.object({
    tablePage: transformToNumber,
  }),
  EditCustomRoles: z.object({
    editModeType: transformToString,
  }),
};
